




















import axios from 'axios'
import {Component, Vue} from "vue-property-decorator";

@Component
export default class board extends Vue {
    md_data = '';
    is_admin = sessionStorage.getItem('user');
    $config: any

    post_board(vl: string) {
        axios.post(`${this.$config.url}/group/board/post`, {
            board: vl
        })
            .then(res => this.$config.notice(res.data))
            .catch(err => this.$config.err_notice(this, err))
    }

    mounted() {
        axios.get(`${this.$config.url}/board`)
            .then(res => {
                this.md_data = res.data
            })
            .catch(err => this.$config.err_notice(this, err))
    }
}
